import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    contacts: [],
    currentChat: undefined,
    messages: [],
    isContactsLoading: true
}

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setContacts: (state, action) => {
            state.contacts = action.payload
        },
        setCurrentChat: (state, action) => {
            state.currentChat = action.payload
        },
        setMessages: (state, action) => {
            state.messages = action.payload
        },
        setIsContactsLoading: (state, action) => {
            state.isContactsLoading = action.payload
        },
        resetChatState: (state) => {
            state.contacts = [];
            state.currentChat = undefined;
            state.messages = []
            state.isContactsLoading = true;
        }
    },
});

export const { setCurrentChat, setIsContactsLoading, setContacts, setMessages, resetChatState } = chatSlice.actions;

export default chatSlice.reducer;